import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'

export type HeaderGroupProps = {
    info?: string
    title?: string
    subtitle?: string
    percentage?: number
    growth?: boolean
}

const HeaderGroup = ({title = '', subtitle = '', info = '', percentage, growth = false}: HeaderGroupProps) => {
    return <Group>
        <div>
            <Title>
                {i18n(title)}
                
                <LiveTooltip position="bottom" content={i18n(info)}>
                    <i className="fas fa-info-circle"/> 
                </LiveTooltip>
            </Title>
            
            <div className='items'>
                <span className='item-value'>{subtitle}</span>

                <span className='percentual'> 
                    <i className={growth ? 'far fa-arrow-up' : 'far fa-arrow-down'}></i>
                    {percentage}%
                </span>
            </div>
        </div>
    </Group> 
}

export default HeaderGroup;


const Group = styled.div`
    height: 58px;
    display: flex;
    align-items: center;
	justify-content: flex-start;
    font-family: ${({theme}) => theme['font-semibold']};
    color: ${({theme}) => theme['gray-800']};      
    font-size: 12px;
    font-weight: 600;

    &:last-child{
        border-right: 0;
    }
    
    .principle-icon {
    	background: ${({theme}) => theme['blue-700']};
        min-width: 32px;
        width: 48px;
        height: 48px;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;    
    	color: ${({theme}) => theme['gray-0']};  
        font-size: 22px;
    }
    
    .items {
    	display: flex;
        gap: 8px;
        align-items: center;
        line-height: 0.7;
    }
    
    .percentual {
    	font-size: 14px;
        color: ${({theme}) => theme['gray-600']};
        font-weight: 400;
        text-wrap: nowrap;

        i {
        	font-size: 12px;
            margin-right: 2px;
        }
    }
    
    .item-value{
        font-size: 32px;
        font-weight: 600;
        color: ${({theme}) => theme['gray-800']};
        padding: 2px;
    }
`

const Title = styled.div`
        color: ${({theme}) => theme['gray-600']};        
    	font-family: ${({theme}) => theme['font-semibold']};    
        text-transform: uppercase;
        font-size: 12px;
        margin: 2px 0;

        i{
            cursor: pointer;
            color: ${({theme}) => theme['gray-500']};    
            font-size: 12px;    
            font-weight: 400;
            margin-left: 4px;
        }
`

